var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "navbar" },
    [
      _c(
        "div",
        { staticClass: "header-logo", on: { click: _vm.toggleSideBar } },
        [
          _c("img", {
            attrs: { src: _vm.logoUrl || _vm.defaultLogo, alt: _vm.tenantName },
          }),
          _vm._v(" "),
          _c(
            "span",
            { staticClass: "title", staticStyle: { "margin-left": "20px" } },
            [_vm._v(_vm._s(_vm.projectDesc))]
          ),
        ]
      ),
      _vm._v(" "),
      _c("div", { staticClass: "project-list-wrapper" }, [
        _vm.showLeftArrow
          ? _c(
              "div",
              {
                staticClass: "scroll-arrow left-arrow",
                on: {
                  click: function ($event) {
                    return _vm.scroll(-200)
                  },
                },
              },
              [_vm._v("\n    ◀\n  ")]
            )
          : _vm._e(),
        _vm._v(" "),
        _c(
          "div",
          {
            ref: "projectList",
            staticClass: "project-list",
            on: { scroll: _vm.checkOverflow },
          },
          [
            _vm._l(_vm.projects, function (item) {
              return _c(
                "div",
                {
                  key: item.permissionKey,
                  staticClass: "project-item",
                  class: {
                    active:
                      _vm.$store.state.permission.currPermissionKey ===
                      item.permissionKey,
                  },
                  on: {
                    click: function ($event) {
                      return _vm.switchObj(item)
                    },
                  },
                },
                [
                  ["homeData", "visualizeData"].includes(item.permissionKey)
                    ? [
                        _c("i", {
                          staticClass: "iconfont-woker iconfont",
                          class: item.icon,
                          staticStyle: { "font-size": "20px" },
                        }),
                        _vm._v(" "),
                        _c("span", [_vm._v(_vm._s(item.name))]),
                      ]
                    : [
                        _c(
                          "el-popover",
                          {
                            staticStyle: { top: "48px" },
                            attrs: {
                              placement: "bottom",
                              trigger: "hover",
                              "popper-class": "menu-pop",
                              "visible-arrow": false,
                            },
                          },
                          [
                            _c(
                              "div",
                              {
                                staticClass: "content",
                                class: {
                                  flexBox:
                                    _vm
                                      .getRoutes(item)
                                      .findIndex(function (route) {
                                        return (
                                          route.children &&
                                          route.children.length
                                        )
                                      }) !== -1,
                                },
                              },
                              _vm._l(_vm.getRoutes(item), function (route, k) {
                                return _c("SideMenu", {
                                  key: k,
                                  attrs: {
                                    index: k,
                                    item: route,
                                    "base-path": route.path,
                                  },
                                })
                              }),
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                attrs: { slot: "reference" },
                                on: {
                                  click: function ($event) {
                                    $event.stopPropagation()
                                  },
                                },
                                slot: "reference",
                              },
                              [
                                _c("i", {
                                  staticClass: "iconfont-woker iconfont",
                                  class: item.icon,
                                  staticStyle: { "font-size": "20px" },
                                }),
                                _vm._v(" "),
                                _c("span", [_vm._v(_vm._s(item.name))]),
                              ]
                            ),
                          ]
                        ),
                      ],
                ],
                2
              )
            }),
            _vm._v(" "),
            _vm.showRightArrow
              ? _c(
                  "div",
                  {
                    staticClass: "scroll-arrow right-arrow",
                    on: {
                      click: function ($event) {
                        return _vm.scroll(200)
                      },
                    },
                  },
                  [_vm._v("\n    ▶\n  ")]
                )
              : _vm._e(),
          ],
          2
        ),
      ]),
      _vm._v(" "),
      _vm.buttonControl.indexOf("message") > -1
        ? _c(
            "div",
            { staticClass: "msg" },
            [
              _c(
                "el-tooltip",
                {
                  attrs: {
                    effect: "dark",
                    content: "消息提醒",
                    placement: "bottom",
                  },
                },
                [
                  _c(
                    "el-badge",
                    {
                      staticClass: "msgcon",
                      attrs: { value: _vm.msgNum, hidden: _vm.msgNum == 0 },
                      nativeOn: {
                        click: function ($event) {
                          return _vm.toMessage($event)
                        },
                      },
                    },
                    [
                      _c("div", { staticClass: "msgbox" }, [
                        _c("i", { staticClass: "el-icon-message-solid icon" }),
                      ]),
                    ]
                  ),
                ],
                1
              ),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.UnionList.length > 0
        ? _c(
            "div",
            { staticClass: "project-union " },
            [
              [
                _c(
                  "el-popover",
                  {
                    attrs: {
                      placement: "bottom",
                      trigger: "hover",
                      "popper-class": "menu-pop",
                      "visible-arrow": false,
                    },
                  },
                  [
                    _vm._l(_vm.UnionList, function (item, index) {
                      return _c(
                        "div",
                        {
                          key: item.id,
                          staticClass: "content",
                          class: { flexBox: true },
                        },
                        [
                          _c(
                            "div",
                            {
                              staticClass: "menu1",
                              on: {
                                click: function ($event) {
                                  return _vm.handleJump(item)
                                },
                              },
                            },
                            [
                              _vm._v(
                                "\n            " +
                                  _vm._s(index + 1 + "." + item.unionName) +
                                  "\n          "
                              ),
                            ]
                          ),
                        ]
                      )
                    }),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        attrs: { slot: "reference" },
                        on: {
                          click: function ($event) {
                            $event.stopPropagation()
                          },
                        },
                        slot: "reference",
                      },
                      [
                        _c("i", {
                          staticClass: "iconfont-woker iconfont",
                          staticStyle: { "font-size": "1rem" },
                        }),
                        _vm._v(" "),
                        _c("span", [_vm._v("联盟门户")]),
                      ]
                    ),
                  ],
                  2
                ),
              ],
            ],
            2
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "kefu" },
        [
          _c(
            "el-dropdown",
            {
              staticClass: "avatar-container",
              attrs: { trigger: "click" },
              nativeOn: {
                click: function ($event) {
                  return _vm.showHandle()
                },
              },
            },
            [
              _c("div", { staticClass: "avatar-kefu" }, [
                _c("div", { staticClass: "delivery-t" }, [_vm._v("技术支持")]),
                _vm._v(" "),
                _c("i", { staticClass: "el-icon-caret-bottom" }),
              ]),
              _vm._v(" "),
              _c(
                "el-dropdown-menu",
                {
                  staticClass: "user-dropdown1",
                  attrs: { slot: "dropdown" },
                  slot: "dropdown",
                },
                [
                  _c("el-dropdown-item", { staticStyle: { width: "275px" } }, [
                    _c("div", { staticClass: "service_content" }, [
                      _c("div", { staticClass: "phone" }, [
                        _vm._v("客服电话：18124271751"),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "server" }, [
                        _vm._v("工作时间：周一至周五（9:00-18:00)"),
                      ]),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass: "factorys_wechat",
                          class: _vm.repairWechatImg
                            ? "dis_just_between"
                            : "dis_just_center",
                        },
                        [
                          _c(
                            "div",
                            { staticClass: "factorys" },
                            [
                              _c("el-image", {
                                attrs: {
                                  src: require("@/assets/images/common/customer-we.png"),
                                },
                              }),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  staticClass: "wechat mt-20",
                                  attrs: { slot: "reference" },
                                  on: {
                                    click: function ($event) {
                                      $event.stopPropagation()
                                    },
                                  },
                                  slot: "reference",
                                },
                                [_vm._v("客服微信")]
                              ),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _vm.repairWechatImg
                            ? _c(
                                "div",
                                { staticClass: "factorys" },
                                [
                                  _c("el-image", {
                                    attrs: { src: _vm.repairWechatImg },
                                  }),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    {
                                      staticClass: "wechat mt-20",
                                      attrs: { slot: "reference" },
                                      on: {
                                        click: function ($event) {
                                          $event.stopPropagation()
                                        },
                                      },
                                      slot: "reference",
                                    },
                                    [_vm._v("报修微信群")]
                                  ),
                                ],
                                1
                              )
                            : _vm._e(),
                        ]
                      ),
                    ]),
                  ]),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "right-menu" },
        [
          _c(
            "el-popover",
            {
              attrs: {
                placement: "top",
                width: "auto",
                trigger: "hover",
                "popper-class": "account-info",
              },
            },
            [
              _vm.$store.state.user.userInfo
                ? _c("div", { staticClass: "userBox" }, [
                    _c("div", { staticClass: "userBox-title" }, [
                      _c("span", [_vm._v("账户信息")]),
                    ]),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "userBox-item" },
                      [
                        _vm._v("\n          ·"),
                        _c("span", [_vm._v("头像")]),
                        _vm._v("：\n          "),
                        _c(
                          "el-upload",
                          {
                            attrs: {
                              action: "#",
                              "show-file-list": false,
                              "auto-upload": false,
                              accept: "image/png, image/jpeg, image/jpg",
                              "on-change": _vm.handleAvatarChange,
                            },
                          },
                          [
                            _c(
                              "div",
                              { staticClass: "avatar-edit-wrapper" },
                              [
                                _c("el-image", {
                                  staticStyle: {
                                    width: "50px",
                                    height: "50px",
                                    cursor: "pointer",
                                    "border-radius": "10px",
                                  },
                                  attrs: {
                                    src:
                                      _vm.$store.state.user.avatarUrl ||
                                      require("@/assets/images/avatar.png"),
                                  },
                                }),
                                _vm._v(" "),
                                _c("i", {
                                  staticClass:
                                    "el-icon-camera-solid avatar-edit-icon",
                                }),
                              ],
                              1
                            ),
                          ]
                        ),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c("div", { staticClass: "userBox-item" }, [
                      _vm._v("\n          ·"),
                      _c("span", [_vm._v("姓名")]),
                      _vm._v(
                        "：" +
                          _vm._s(_vm.$store.state.user.userName) +
                          "\n        "
                      ),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "userBox-item" }, [
                      _vm._v("\n          ·"),
                      _c("span", [_vm._v("所在部门")]),
                      _vm._v(
                        "：" +
                          _vm._s(_vm.$store.state.user.userInfo.departName) +
                          "\n        "
                      ),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "userBox-item" }, [
                      _vm._v("\n          ·"),
                      _c("span", [_vm._v("教工号")]),
                      _vm._v(
                        "：" +
                          _vm._s(_vm.$store.state.user.userInfo.userNumber) +
                          "\n        "
                      ),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "userBox-item" }, [
                      _vm._v("\n          ·"),
                      _c("span", [_vm._v("上次登录")]),
                      _vm._v(
                        "：" +
                          _vm._s(_vm.$store.state.user.userInfo.lastLoginTime) +
                          "\n        "
                      ),
                    ]),
                  ])
                : _vm._e(),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "avatar-wrapper",
                  attrs: { slot: "reference" },
                  slot: "reference",
                },
                [
                  _c("img", {
                    staticClass: "user-avatar",
                    attrs: {
                      src:
                        _vm.$store.state.user.avatarUrl ||
                        require("@/assets/images/avatar.png"),
                    },
                  }),
                  _vm._v(" "),
                  _c("span", { staticClass: "userName" }, [
                    _vm._v(_vm._s(_vm.$store.state.user.userName)),
                  ]),
                ]
              ),
            ]
          ),
          _vm._v(" "),
          _c(
            "el-dropdown",
            { staticClass: "avatar-container", attrs: { trigger: "click" } },
            [
              _c("div", { staticClass: "avatar-wrapper" }, [
                _c("span", { staticClass: "iconfont-woker iconfont" }, [
                  _vm._v(""),
                ]),
              ]),
              _vm._v(" "),
              _c(
                "el-dropdown-menu",
                {
                  staticClass: "user-dropdown",
                  attrs: { slot: "dropdown" },
                  slot: "dropdown",
                },
                [
                  _c(
                    "el-dropdown-item",
                    {
                      nativeOn: {
                        click: function ($event) {
                          return _vm.logout($event)
                        },
                      },
                    },
                    [
                      _c("span", { staticStyle: { display: "block" } }, [
                        _vm._v("退出登录"),
                      ]),
                    ]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c("repair-box", { ref: "repairBox" }),
      _vm._v(" "),
      _c("cropper-dialog", {
        ref: "avatarCropper",
        on: { handleSave: _vm.handleAvatarCrop },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }